import { Skeleton } from "@/app/admin/_common/ui/skeleton";
import { useIsMobile } from "@/app/admin/_hooks/useIsMobile";

export default function PromoListSkeleton() {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className="flex flex-col bg-card">
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="flex items-center gap-2.5 border-b border-border px-4 py-3 last:border-0"
          >
            <div className="flex min-w-0 flex-1 flex-col gap-1.5">
              <div className="flex items-center gap-2">
                <Skeleton className="h-3.5 w-24" />
                <Skeleton className="h-3 w-14" />
              </div>
              <div className="flex items-center gap-2">
                <Skeleton className="h-4 w-16 rounded-[7px]" />
                <Skeleton className="h-3 w-20" />
              </div>
            </div>
            <Skeleton className="size-4 flex-none rounded" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden border-t border-border bg-card md:rounded-md md:border md:border-border">
      <div className="flex h-8 items-center gap-4 border-b border-border/50 bg-muted/50 px-4">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-3 w-16" />
        <Skeleton className="ml-auto h-3 w-24" />
        <Skeleton className="h-3 w-16" />
        <Skeleton className="h-3 w-20" />
      </div>
      {Array.from({ length: 10 }).map((_, i) => (
        <div
          key={i}
          className="flex h-[42px] items-center gap-4 border-b border-border/50 px-4 last:border-0"
        >
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-3 w-14" />
          <Skeleton className="ml-auto h-3 w-40" />
          <Skeleton className="h-4 w-16 rounded-[7px]" />
          <Skeleton className="h-3 w-20" />
          <Skeleton className="size-4 flex-none rounded" />
        </div>
      ))}
    </div>
  );
}
